import type { HTMLAttributes } from "react";
import * as Yup from "yup";
import { ColumnKey, InvoiceFormValues } from "./types";

export const apiEndpoint = `/invoice-parties`;
export const ColumnOptions: { value: ColumnKey; label: string }[] = [
  { value: "uid", label: "UID" },
  { value: "name", label: "Name" },
  { value: "company", label: "Company" },
  { value: "emailAddress", label: "Email" },
  { value: "account", label: "Account" },
  { value: "activityState", label: "Is Active" },
  {
    value: "campaignLimitedDataTransfer",
    label: "Campaign Limit Data Transfer",
  },
  { value: "comment", label: "Comment" },
];

// Invoice Form: validation, fields and initial values (patterned after title module)
export const InvoiceValidationSchema = Yup.object({
  name: Yup.string().trim().required("Name is required"),
  company: Yup.string().trim().required("Company is required"),
  emailAddress: Yup.string()
    .trim()
    .required("Email is required")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Please enter a valid email address",
    ),
  account: Yup.number()
    .typeError("Account must be a number")
    .required("Account is required")
    .test("max-9-digits", "Account cannot exceed 9 digits", (val) => {
      if (val === undefined || val === null) return false; // required handles empty case
      const digits = Math.abs(Math.trunc(val)).toString();
      return digits.length <= 9;
    }),
});

export const InvoiceFormInitialValues: InvoiceFormValues = {
  name: "",
  company: "",
  emailAddress: "",
  account: null,
  activityState: true,
  campaignLimitedDataTransfer: false,
};

export const InvoiceFormFields: {
  name: string;
  label: string;
  type: string;
  inputMode?: HTMLAttributes<HTMLElement>["inputMode"];
}[] = [
  { name: "name", label: "Name", type: "text" },
  { name: "company", label: "Company", type: "text" },
  { name: "emailAddress", label: "Email", type: "email" },
  // Rendered as text (not number) so the change handler can strip stray
  // characters: a number input reports value "" for partial input like "E",
  // leaving it stuck in the box.
  { name: "account", label: "Account", type: "text", inputMode: "numeric" },
  { name: "comment", label: "Comment", type: "textarea" },
];

export const DefaultHiddenColumns: ColumnKey[] = [
  "uid",
  "updateTstamp",
  "campaignLimitedDataTransfer",
];

// Server-side sorting state (limited to allowed fields)
export const AllowedSortFields = [
  "name",
  "company",
  "emailAddress",
  "updateTstamp",
] as const;
